import React from "react";
import { Link } from "gatsby";

import logo from "../img/logo.svg";
import facebook from "../img/social/facebook.svg";
import instagram from "../img/social/instagram.svg";
import twitter from "../img/social/twitter.svg";
import vimeo from "../img/social/vimeo.svg";
import { pageWidth } from "../constants";

const Footer = class extends React.Component {
  render() {
    return (
      <div
        style={{
          borderTop: "1px solid #bbb",
          maxWidth: "100%",
        }}
      >
        <div class="mx-auto" style={{ width: pageWidth, maxWidth: "100%" }}>
          <div class="mx-2 flex flex-row my-2">
            <div class="font-serif text-gray-600 mr-8">
              Scientia potentia est
            </div>
            <Link className="font-serif underline" to="/books">
              See all books
            </Link>
          </div>
        </div>
      </div>
    );
  }
};

export default Footer;
